export const addComment = {
  edit: '编辑',
  delete: '删除',
  resolve: '已解决',
  notResolve: '未解决',
  close: '关闭',
  noPermission: '没有权限',
  permissionPrompt: '拒绝录音权限后，需要退出公众号重新授权',
  loading: '加载中',
  allMember: '所有人',
  oversizeAlert: '上传文件大小超过系统规定上限(200M),请重新选择图片',
  cancelRecord: '取消录音',
  recordFailed: '录音失败: {msg}',
  comment: '评论',
  addComment: '添加评论',
  send: '发送',
  holdMessage: '按住说话',
  looseMessage: '松开发送',
  confirmDelete: '删除评论后不可恢复，确认删除吗',
  cancel: '取消',
  ok: '确定',
  commentDelete: '评论已被删除'
}
